import { logWarning } from '@databases/logs';

import { getConfluenceService } from '@canvas/atlassian-service/confluence';

import { fetchConfluenceData, rejectOnError } from './fetch.ts';

export async function addContentLabels(
  contentId: string,
  labels: string[]
): Promise<void> {
  if (labels.length === 0) {
    return;
  }

  await fetchConfluenceData(`/rest/api/content/${encodeURIComponent(contentId)}/label`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    body: JSON.stringify(labels.map((label) => ({ prefix: 'global', name: label })))
  }).then(rejectOnError);
}

export async function removeContentLabel(
  contentId: string,
  label: string
): Promise<void> {
  await fetchConfluenceData(
    `/rest/api/content/${encodeURIComponent(contentId)}/label?${new URLSearchParams({
      name: label
    })}`,
    {
      method: 'DELETE'
    }
  ).then(rejectOnError);
}

export const autoCompleteLabel = async (
  query: string,
  contentId: string | undefined
): Promise<string[]> => {
  try {
    const confluenceService = getConfluenceService();
    const response = await confluenceService.getContentLabels({
      contentId,
      searchText: query
    });

    return [
      ...response.suggestedLabels.map((label) => label.name),
      ...response.otherLabels.map((label) => label.name)
    ];
  } catch (error) {
    logWarning(
      new Error('Could not autocomplete labels', {
        cause: String(error)
      })
    );
    return [];
  }
};
